export enum BopTestType {
    None = 0,
    FacilityTest = 1,
    FieldTest = 2,
}